import React from "react";
import './Developer.css'
function SideMenu() {
    return (
        <>
            <section className="sidemenu">
                <div className="row sidemenu-row">
                    <div className="col-lg-12 menu-head">
                        <h1>Welcome</h1>
                        <div className="dropdown-menu-main">
                            <div className="dropdown">
                                <button className="dropbtn">Welcome</button>
                                <div className="dropdown-content">
                                    <a href="#">Gaming Arcade Mainnet</a>
                                    <a href="#">Gaming Arcade Testnet</a>
                                    <a href="#">Token List</a>
                                    <a href="#">Help build in contracts</a>
                                    <a href="#">Full node Development</a>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-menu-main">
                            <div className="dropdown">
                                <button className="dropbtn">Network Details</button>
                                <div className="dropdown-content">
                                    <a href="#">Gaming Arcade Mainnet</a>
                                    <a href="#">Gaming Arcade Testnet</a>
                                    <a href="#">Token List</a>
                                    <a href="#">Help build in contracts</a>
                                    <a href="#">Full node Development</a>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-menu-main">
                            <div className="dropdown">
                                <button className="dropbtn">Tools</button>
                                <div className="dropdown-content">
                                    <a href="#">Gaming Arcade Mainnet</a>
                                    <a href="#">Gaming Arcade Testnet</a>
                                    <a href="#">Token List</a>
                                    <a href="#">Help build in contracts</a>
                                    <a href="#">Full node Development</a>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-menu-main">
                            <div className="dropdown">
                                <button className="dropbtn">Develop on Gaming Arcade</button>
                                <div className="dropdown-content">
                                    <a href="#">Gaming Arcade Mainnet</a>
                                    <a href="#">Gaming Arcade Testnet</a>
                                    <a href="#">Token List</a>
                                    <a href="#">Help build in contracts</a>
                                    <a href="#">Full node Development</a>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-menu-main">
                            <div className="dropdown">
                                <button className="dropbtn">Develope on tT Wallet</button>
                                <div className="dropdown-content">
                                    <a href="#">Gaming Arcade Mainnet</a>
                                    <a href="#">Gaming Arcade Testnet</a>
                                    <a href="#">Token List</a>
                                    <a href="#">Help build in contracts</a>
                                    <a href="#">Full node Development</a>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-menu-main">
                            <div className="dropdown">
                                <button className="dropbtn">Gaming Arcade Bridge</button>
                                <div className="dropdown-content">
                                    <a href="#">Gaming Arcade Mainnet</a>
                                    <a href="#">Gaming Arcade Testnet</a>
                                    <a href="#">Token List</a>
                                    <a href="#">Help build in contracts</a>
                                    <a href="#">Full node Development</a>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-menu-main">
                            <div className="dropdown">
                                <button className="dropbtn">FAQs</button>
                                <div className="dropdown-content">
                                    <a href="#">Gaming Arcade Mainnet</a>
                                    <a href="#">Gaming Arcade Testnet</a>
                                    <a href="#">Token List</a>
                                    <a href="#">Help build in contracts</a>
                                    <a href="#">Full node Development</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default SideMenu;